import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'playlist-container',
  templateUrl: './playlist-container.template.html',
  styleUrls: ['./playlist-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaylistContainer extends StaticContainer {
  private getPlaylistMeta(video){
    return video.rows && video.rows.find(r => r.meta && r.meta.obj_type === 'PlayList');
  }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/playlist-container/playlist-container.component.ts